module.exports = __webpack_public_path__ + "img/map_s.91d292f7.jpg";